import React from 'react'
import styled from 'styled-components'

const Main = styled.main`
  display: flex;
  flex-direction: column;
  height: 100%;
  transition: opacity 0.5s ease;
  opacity: 0;
  background-image: url("/background.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  pointer-events: none;
  justify-content: center;
  & > * {
    opacity: 0;
    transition: opacity 0.5s ease 1s;
  }
  &.on {
    opacity: 1;
    pointer-events: auto;
    & > * {
      opacity: 1;
    }
  }
`

const MainWrapper: React.FC<{ className: string }> = (props) => {
  return (
    <Main className={props.className}>
      {props.children}
    </Main>
  )
}

export default MainWrapper